import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.475 5.107a6 6 0 10-.869 10.299 1 1 0 01.75-.048l3.007 1-1.01-3.002a1 1 0 01.107-.862 6 6 0 00-1.985-7.387zm3.902 7.995a8 8 0 10-4.283 4.277l2.64.877h.003a2 2 0 002.52-2.539l-.88-2.615zM12 10a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zM2.429 12.2c.154-1.107 1.729-1.064 1.997.02a6.002 6.002 0 00.488 3.677c.112.233.129.5.048.746l-.987 2.994L6.94 18.63a.981.981 0 01.851.107c.846.39 1.744.564 2.627.539 1.103.227.815 2.013-.312 1.992a7.818 7.818 0 01-2.916-.622l-2.582.876a1.964 1.964 0 01-2.023-.473 2.003 2.003 0 01-.485-2.036v-.002l.867-2.629A7.998 7.998 0 012.43 12.2z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
